import { dataLayerPush } from './dataLayerPush';

export const profileEvents = {
  profileUpdate: () => dataLayerPush({ event: 'profile_update' }),
};
